// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/hearing-protection.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/hearing-protection/hearing-protection.js';

mount([g0]);
